import { catchErrorInfo, getScene7StockImageModeAsync } from '../main/logics';
import { changeBomColor, changeLiteBomColor, updateFullPreview as updateFullPreviewAction } from '../preview/actions';
import {
  changeLogoEditingStatus,
  hideWaitingCover,
  setCanvasPreview,
  showMessageBox,
  showWaitingCover,
} from '../main/actions';
import { colorType, imprintOptionType, previewType } from '../utils/constants';
import { finishRequestPreview, startRequestPreview } from '../nextgen/actions';
import {
  getCanvasOverVignetteConfig,
  getCartUseScene7Template,
  getCurrentImprintAreaKey,
  getCurrentUpsell,
  getCurrentUpsellItemId,
  getItemId,
  getItemUseScene7Template,
  getStatus,
  getStudioItemType,
  getVendorId,
} from '../main/selectors';
import { getCanvasTextDataDict, getScaleDict } from '../text/selectors';
import {
  getChildItemIdFromBomSelectionForLite,
  getIsLiteParentChildItem,
  getPromoStudioUIType,
} from '../lite/selectors';
import {
  getCurrentUpsellImageDataDict,
  getCurrentUpsellImprintAreaKey,
  getCurrentUpsellTextDataDict,
} from '../upsell/selectors';
import { getFinalBomOptionsSelection, getFirstSelectedColorBomOption } from '../bom/selectors';
import {
  getImprintColors,
  getImprintFormatDetail,
  getImprintOptionType,
  getSelectedImprintAreaKeys,
  getTraditonalImprintColorForImprintKeys,
} from '../imprintarea/selectors';
import { getLiteHasVignette, getSelectedColorBomOptions } from '../preview/selectors';
import { promoStudioUITypeValue, studioItemType } from '../main/constants';
import { requestCanvasPreview, requestFullPreview, setUseScene7TemplateSession } from './apis';
import { retrievalImprintAreaKeys, updateNonDigitalFullPreview } from '../text/logics';

import axios from 'axios';
import { changeCurrentPreviewElementsLogic } from '../nextgen/preview/logics';
import { getAllColorsInUse } from '../userimage/selectors';
import { getCanvasImageDataDict } from '../canvas/selectors';
import { getDefaultColor } from '../imprintarea/logics';
import { getFarthestColorApi } from '../imprintarea/api';
import { getFinalBomOptionsSelectionForUpsellItem } from '../upsell/logics';
import { getFinalTemplateSelection } from '../template/selectors';
import { getIsNextGenUI } from '../nextgen/selectors';
import { setPreviewDefaultImprintColorDict } from '../preview/actions';
import { updateUpellFullPreviewUrl } from '../upsell/actions';

export const generatePreviewUrl = function (selectedBomOption, selectedScene7Url, returnObject = false, size = 1000) {
  let url = '';
  let wid = size;
  const { defaultWidth, defaultHeight, type } = selectedScene7Url;
  if (defaultWidth < defaultHeight) {
    wid = Math.floor((size * defaultWidth) / defaultHeight);
  }
  if (type === previewType.Vignette) {
    url =
      selectedScene7Url.templateUrl.replace(
        selectedScene7Url.placeHolder,
        selectedBomOption.colorReference.substring(1)
      ) + `&wid=${wid}`;
  } else {
    url = selectedScene7Url.url + `&wid=${wid}`;
  }
  if (returnObject) {
    return { url, type, defaultWidth, defaultHeight };
  }
  return url;
};

export const retrievaledFullPreviews = function (
  state,
  updatePreviewsForAll,
  retrievaledImprintAreaKeys,
  selectedImprintAreaKeys
) {
  let digitalTextDataDict = {};
  let selectedTemplateDict = {};
  let scaleDict = {};
  for (let imprintAreaKey of updatePreviewsForAll ? selectedImprintAreaKeys : retrievaledImprintAreaKeys) {
    const textDataDict = getCanvasTextDataDict(state);
    if (textDataDict[imprintAreaKey] !== undefined) {
      digitalTextDataDict[imprintAreaKey] = textDataDict[imprintAreaKey];
    }

    const finalTemplateSelection = getFinalTemplateSelection(state);
    if (finalTemplateSelection[imprintAreaKey] !== undefined) {
      selectedTemplateDict[imprintAreaKey] = finalTemplateSelection[imprintAreaKey];
    }

    let scale = '';
    const currentStudioItemType = getStudioItemType(state);
    const currentImprintOptionType = getImprintOptionType(state, imprintAreaKey);
    if (
      currentStudioItemType === studioItemType.nonDigital &&
      (currentImprintOptionType === imprintOptionType.TextOnly ||
        currentImprintOptionType === imprintOptionType.TextLogo)
    ) {
      scale = getScaleDict(state)[imprintAreaKey];
    } else {
      scale = 0;
    }
    scaleDict[imprintAreaKey] = scale;
  }
  let retrievaledFullPreviewData = {};
  retrievaledFullPreviewData = {
    digitalTextDataDict,
    selectedTemplateDict,
    scaleDict,
  };
  return retrievaledFullPreviewData;
};

export const updateCanvasPreview = (selectedSpecialImageData) => (dispatch, getState) => {
  const state = getState();
  const currentImprintAreaKey = getCurrentImprintAreaKey(state);
  const itemId = getItemId(state);
  const vendorId = getVendorId(state);
  const imprintFormatDetail = getImprintFormatDetail(state);
  const finalTemplateSelection = getFinalTemplateSelection(state);
  const allColorsInUse = getAllColorsInUse(state, currentImprintAreaKey);
  const selectedTemplate = {};
  if (finalTemplateSelection[currentImprintAreaKey] !== undefined) {
    selectedTemplate[currentImprintAreaKey] = finalTemplateSelection[currentImprintAreaKey];
  }

  let canvasPreviewRequest = {
    itemId,
    vendorId,
    image: { [currentImprintAreaKey]: [selectedSpecialImageData].filter(Boolean) },
    imprintFormat: [imprintFormatDetail.format],
    selectedTemplate: selectedTemplate,
    scale: { [currentImprintAreaKey]: 0 },
    selectedImprintAreaKey: currentImprintAreaKey,
    applyBomColor: false,
    allColorsInUse: { [currentImprintAreaKey]: allColorsInUse },
  };

  requestCanvasPreview(canvasPreviewRequest).then((response) => {
    const canvasOverVignetteConfig = getCanvasOverVignetteConfig(state);
    const vignette = canvasOverVignetteConfig && canvasOverVignetteConfig.vignette;
    let canvasPreview = response.data?.find((preview) => preview.url.indexOf(vignette) !== -1);
    if (canvasPreview) dispatch(setCanvasPreview({ imprintAreaKey: currentImprintAreaKey, canvasPreview }));
  });
};

let cancelTokenSource = null;
export const updateFullPreview = function (props = {}) {
  return (dispatch, getState) => {
    const { updatePreviewsForAll = false, successCallback, finallyCallback } = props;
    const state = getState();
    const hasVignette = getLiteHasVignette(state);
    const uiType = getPromoStudioUIType(state);
    const isLite = uiType === promoStudioUITypeValue.LiteUI;
    // do not call the api when product with liteUI has no vignette
    if (isLite && !hasVignette) {
      return;
    }

    const itemId = getIsLiteParentChildItem(state) ? getChildItemIdFromBomSelectionForLite(state) : getItemId(state);
    const vendorId = getVendorId(state);
    const imageDataDict = getCanvasImageDataDict(state);
    const currentImprintAreaKey = getCurrentImprintAreaKey(state);
    const selectedImprintAreaKeys = getSelectedImprintAreaKeys(state);
    const retrievaledData = retrievalImprintAreaKeys(
      state,
      updatePreviewsForAll,
      currentImprintAreaKey,
      selectedImprintAreaKeys,
      false
    );
    let retrievaledFullPreviewData = retrievaledFullPreviews(
      state,
      updatePreviewsForAll,
      retrievaledData.retrievaledImprintAreaKeys,
      selectedImprintAreaKeys
    );
    let textDataDict = {};
    const currentStudioItemType = getStudioItemType(state);
    if (
      currentStudioItemType === studioItemType.digital ||
      currentStudioItemType === studioItemType.screenPrintedDigital
    ) {
      textDataDict = retrievaledFullPreviewData.digitalTextDataDict;
    } else if (currentStudioItemType === studioItemType.nonDigital) {
      textDataDict = retrievaledData.nonDigitalTextDataDict;
      // record data when color is null
      let isColorNull = false;
      Object.keys(textDataDict).forEach((imprintAreaKey) => {
        let textDataList = textDataDict[imprintAreaKey] || [];
        textDataList.forEach((textData) => {
          if (!textData.color) {
            isColorNull = true;
          }
        });
      });
      if (isColorNull) {
        const errorMsg = JSON.stringify({
          textDict: state.textDict,
          textLineDict: state.textLineDict,
          imageDict: state.imageDict,
          imprintColorDict: state.imprintColorDict,
        });
        dispatch(catchErrorInfo({ message: 'color is null before executive requestFullPreview', stack: errorMsg }));
      }
    }
    const selectedBom = getFinalBomOptionsSelection(state);
    let bomOption = {
      bomOptions: selectedBom.generalOptions,
      pseudoParentChildQuestionOptionDictionaryList: selectedBom.pseudoParentChildQuestionOptionDictionaries,
      quantity: selectedBom.quantity,
      selectedBomColorReference: (
        getSelectedColorBomOptions(state)[0]?.colorReference ||
        getFirstSelectedColorBomOption(state)?.colorReference ||
        ''
      ).replace('#', ''),
    };
    const status = getStatus(state);
    let fullPreviewRequest = {
      itemId,
      vendorId,
      image: imageDataDict,
      text: textDataDict,
      imprintFormat: retrievaledData.imprintAreaList,
      imprintLocationCode: retrievaledData.imprintLocationDict,
      logoLocationCode: retrievaledData.logoLocationDict,
      selectedTemplate: retrievaledFullPreviewData.selectedTemplateDict,
      bomOption,
      scale: retrievaledFullPreviewData.scaleDict,
      status,
      selectedImprintAreaKey: retrievaledData.selectedImprintAreaKey,
      applyBomColor: false,
      imprintColor: getTraditonalImprintColorForImprintKeys(state),
    };

    if (cancelTokenSource) {
      cancelTokenSource.cancel();
    }
    cancelTokenSource = axios.CancelToken.source();

    currentStudioItemType !== studioItemType.nonDigital && !props.noWaiting && dispatch(showWaitingCover());

    const useScene7TemplateRequest = {
      itemUseScene7Template: getItemUseScene7Template(state),
      cartUseScene7Template: getCartUseScene7Template(state),
      isEdit: status.toUpperCase() === 'NEW' ? false : true,
    };
    const isNextGenUI = getIsNextGenUI(state);

    setUseScene7TemplateSession(useScene7TemplateRequest, { cancelToken: cancelTokenSource.token })
      .then(() => {
        cancelTokenSource = null;
        dispatch(startRequestPreview());
        return requestFullPreview(fullPreviewRequest);
      })
      .then(function (response) {
        let fullPreview = response.data.fullPreview;
        if (Object.keys(fullPreview).length !== 0) {
          //update full preview to store
          dispatch(updateFullPreviewAction(fullPreview));
          successCallback && successCallback();
        } else {
          dispatch(hideWaitingCover());
        }
        dispatch(finishRequestPreview());
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
        dispatch(hideWaitingCover());
      })
      .finally(() => {
        if (isNextGenUI) {
          dispatch(changeLogoEditingStatus({ forceHideApplyNotice: true }));
          dispatch(changeCurrentPreviewElementsLogic());
        }
        currentStudioItemType !== studioItemType.nonDigital && dispatch(hideWaitingCover());
        finallyCallback && finallyCallback();
      });
  };
};

export const updateUpsellFullPreview = function (successCallback) {
  return (dispatch, getState) => {
    const state = getState();
    const vendorId = getVendorId(state);
    const currentUpsell = getCurrentUpsell(state);
    const upsellItemId = getCurrentUpsellItemId(state);
    const upsellImageDataDict = getCurrentUpsellImageDataDict(state);
    const upsellTextDataDict = getCurrentUpsellTextDataDict(state);
    const bomOption = getFinalBomOptionsSelectionForUpsellItem(currentUpsell);
    const status = getStatus(state);
    const upsellImprintAreaKey = getCurrentUpsellImprintAreaKey(state);

    const useScene7TemplateRequest = {
      itemUseScene7Template: getItemUseScene7Template(state),
      cartUseScene7Template: getCartUseScene7Template(state),
      isEdit: status.toUpperCase() === 'NEW' ? false : true,
    };
    setUseScene7TemplateSession(useScene7TemplateRequest).then(() => {
      let fullPreviewRequest = {
        itemId: upsellItemId,
        vendorId,
        image: upsellImageDataDict,
        text: upsellTextDataDict,
        imprintFormat: currentUpsell.imprintAreas,
        imprintLocationCode: currentUpsell.imprintLocationCode,
        logoLocationCode: currentUpsell.logoLocationCode,
        selectedTemplate: {},
        bomOption,
        scale: currentUpsell.scaleDict,
        status,
        selectedImprintAreaKey: upsellImprintAreaKey,
        applyBomColor: true,
      };
      //dispatch(showWaitingCover());
      requestFullPreview(fullPreviewRequest)
        .then(function (response) {
          let fullPreview = response.data.fullPreview[upsellImprintAreaKey];
          dispatch(updateUpellFullPreviewUrl({ upsellItemId, fullPreviewUrl: fullPreview[0].url }));
          successCallback && successCallback();
        })
        .catch((err) => {
          dispatch(showMessageBox(err.message));
          dispatch(hideWaitingCover());
        })
        .finally(() => {
          dispatch(hideWaitingCover());
        });
    });
  };
};

//type: color|preview
export const processUrls = function (type, moreViewIndexInfo, rawUrls) {
  const invalidRawUrls = rawUrls.some((item) => typeof item === 'undefined');
  if (invalidRawUrls) return null;
  let selectedIndex = type === 'color' ? moreViewIndexInfo.colorIndex : moreViewIndexInfo.previewIndex;
  return rawUrls.map((item, index) => {
    item.isSelected = selectedIndex === index;
    return item;
  });
};

export const checkStockImageType = function (bomOptions) {
  return (dispatch, getState) => {
    // Only monochrome products support multiple types of stock images.
    if (bomOptions.length === 1) {
      dispatch(getScene7StockImageModeAsync(bomOptions[0]));
    }
  };
};
export const changePreviewDefaultImprintColor = (props) => (dispatch, getState) => {
  const { imprintAreaKeys, successCallback } = props;
  const state = getState();
  const itemType = getStudioItemType(state);
  if (itemType !== studioItemType.digital) {
    imprintAreaKeys.forEach((imprintAreaKey) => {
      const imprintColors = getImprintColors(state, imprintAreaKey);
      const selectedColorBomOptions = getSelectedColorBomOptions(state);
      const traditionalImprintColors = imprintColors.filter(
        (i) => i.colorType === colorType.Traditional && i.colorReference
      );
      const defaultColor = getDefaultColor(traditionalImprintColors);
      const request = {
        colorList: traditionalImprintColors,
        colorReference: selectedColorBomOptions[0]?.colorReference.replace('#', '') || '',
      };
      getFarthestColorApi(request)
        .then((res) => {
          dispatch(
            setPreviewDefaultImprintColorDict({
              imprintAreaKey,
              defaultImprintColor: res && res.data ? res.data : defaultColor,
            })
          );
        })
        .catch(() => {
          dispatch(
            setPreviewDefaultImprintColorDict({
              imprintAreaKey,
              defaultImprintColor: defaultColor,
            })
          );
        })
        .finally(() => {
          successCallback && successCallback();
        });
    });
  } else successCallback && successCallback();
};

export const changeBomColorSelected = (props) => (dispatch, getState) => {
  const { imprintAreaKeys, selectedIndex } = props;

  const state = getState();
  const uiType = getPromoStudioUIType(state);
  const isLite = uiType === promoStudioUITypeValue.LiteUI;

  if (isLite) {
    dispatch(changeLiteBomColor(selectedIndex));
  } else {
    dispatch(changeBomColor({ imprintAreaKeys, selectedIndex }));
  }
  dispatch(changePreviewDefaultImprintColor({ imprintAreaKeys }));
  dispatch(updateNonDigitalFullPreview({ needUpdatePreview: true }));
};
